import { ChangeEventHandler, MouseEventHandler } from 'react'
import { ChevronLeft } from 'react-feather'
import { FulfillmentCenter, Product } from 'src/features/types'
import { NumberFmt } from 'src/utils'
import * as S from './ProductHeader.styles'

interface FieldProps {
  label: string
  value: any
}

const Field = ({ label, value }: FieldProps) => (
  <S.Label>
    {label}:<S.Text title={value}>{value}</S.Text>
  </S.Label>
)

const FieldNumerical = ({ label, value }: FieldProps) => (
  <S.Label style={{ justifyContent: 'space-between' }}>
    {label}:<S.Text title={value}>{NumberFmt({ value, sufix: '' })}</S.Text>
  </S.Label>
)

const SubFieldNumerical1 = ({ label, value }: FieldProps) => (
  <S.SubLabel1 style={{ justifyContent: 'space-between' }}>
    {label}:<S.Text title={value}>{NumberFmt({ value, sufix: '' })}</S.Text>
  </S.SubLabel1>
)

const SubFieldNumerical2 = ({ label, value }: FieldProps) => (
  <S.SubLabel2 style={{ justifyContent: 'space-between' }}>
    {label}:<S.Text title={value}>{NumberFmt({ value, sufix: '' })}</S.Text>
  </S.SubLabel2>
)

const getBlockedQuantity = (product: Product) => {
  if (!product) return 0

  return product.reservedQuantityReturn
    + product.reservedQuantitySwap
    + product.reservedQuantityTransfers
}

interface Props {
  handleClickSearchButton?: MouseEventHandler<HTMLButtonElement>
  handleClickBackButton?: MouseEventHandler<HTMLButtonElement>
  handleChangeSelect?: ChangeEventHandler<HTMLSelectElement>
  FCs: FulfillmentCenter[],
  currentFC?: number,
  product: Product | null
}

export default ({
  handleClickSearchButton,
  handleClickBackButton,
  handleChangeSelect,
  FCs,
  currentFC,
  product,
}: Props) => (
  <>
    <S.WrapperSection>
      <S.Section>
        <S.Button onClick={handleClickBackButton}>
          <ChevronLeft viewBox='0 0 24 28'/>
          Voltar
        </S.Button>
      </S.Section>
      <S.Section style={{ alignItems: 'end' }}>
        <S.Title>Detalhes do produto</S.Title>
      </S.Section>
    </S.WrapperSection>
    <S.WrapperSection>
      <S.Section style={{ flex: 2.5 }}>
        <Field label='ID Modelo' value={product?.modelId} />
        <Field label='Codigo do Produto' value={product?.code} />
        <Field label='Nome' value={product?.description} />
        <Field label='Categoria' value={product?.category} />
      </S.Section>
      <S.Section>
        <FieldNumerical label='Qtd. Total' value={product?.total} />
        <FieldNumerical label='Qtd. Total sem bloqueado' value={product ? product.total - getBlockedQuantity(product) : 0} />
        <FieldNumerical label='Qtd. Reservada' value={product?.reserved} />
        <SubFieldNumerical1 label='Qtd. Pedidos' value={product?.reservedQuantityOrders} />
        <SubFieldNumerical1 label='Qtd. Bloqueada' value={product ? getBlockedQuantity(product) : 0} />
        <SubFieldNumerical2 label='Qtd. Trocas' value={product?.reservedQuantitySwap} />
        <SubFieldNumerical2 label='Qtd. Devoluções' value={product?.reservedQuantityReturn} />
        <SubFieldNumerical2 label='Qtd. Transferências' value={product?.reservedQuantityTransfers} />
        <FieldNumerical label='Qtd. Disponível' value={product?.available} />
      </S.Section>
    </S.WrapperSection>
    <S.WrapperSection>
      <S.Section>
        <S.Label style={{ flexDirection: 'column' }}>
          Fulfillment Center:
          <S.Select
            value={currentFC}
            onChange={handleChangeSelect}
          >
            {FCs.map(({ id, name }) => (
              <S.Option key={id} value={id}>{name}</S.Option>
            ))}
          </S.Select>
        </S.Label>
      </S.Section>
      <S.Section>
        <S.Label style={{ flexDirection: 'column', alignItems: 'end', justifyContent: 'flex-end' }}>
          <S.Button
            width={16}
            color='#25a37b'
            hoverColor='#2dca98'
            onClick={handleClickSearchButton}
          >
            Buscar
          </S.Button>
        </S.Label>
      </S.Section>
    </S.WrapperSection>
  </>
)
